import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';

const REFERRAL_STORAGE_KEY = 'ps_referred_by';

/**
 * Hook to track and persist referral ID from URL query parameters.
 * Called from the _public layout so it runs on every public page load.
 */
export const useReferralTracker = () => {
  const search = useRouterState({ select: s => s.location.search })

  useEffect(() => {
    const ref = new URLSearchParams(search).get('ref')
    if (ref) {
      localStorage.setItem(REFERRAL_STORAGE_KEY, ref);
    }
  }, [search]);

  const getReferralId = (): string | undefined => {
    return localStorage.getItem(REFERRAL_STORAGE_KEY) || undefined;
  };

  const clearReferralId = () => {
    localStorage.removeItem(REFERRAL_STORAGE_KEY);
  };

  return { getReferralId, clearReferralId };
};
